import { DateTimeFormatter, LocalTime } from "@js-joda/core";
import type { TimePickerProps } from "react-time-picker";

const pickerFormat = DateTimeFormatter.ofPattern("HH:mm");

export function toTimePickerValue(time: LocalTime): TimePickerProps["value"] {
	return time.format(pickerFormat);
}

export function fromTimePickerValue(time: TimePickerProps["value"]): LocalTime {
	return LocalTime.parse(time as string, pickerFormat);
}
